(() => {
  if (window.nailartsProductThumbnailsLoaded) return;
  window.nailartsProductThumbnailsLoaded = true;

  const connect = (control) => {
    if (control.dataset.thumbnailNavigationReady) return true;

    const slider = control.querySelector('[thumbnail-slider]');
    const swiper = slider?.swiper;
    if (!swiper) return false;

    const previous = control.querySelector('[data-thumbnail-prev]');
    const next = control.querySelector('[data-thumbnail-next]');
    if (!previous || !next) return false;

    const update = () => {
      const hasOverflow = Math.abs(swiper.minTranslate() - swiper.maxTranslate()) > 1;
      previous.hidden = !hasOverflow;
      next.hidden = !hasOverflow;
      previous.disabled = !hasOverflow || swiper.isBeginning;
      next.disabled = !hasOverflow || swiper.isEnd;
    };

    previous.addEventListener('click', () => swiper.slidePrev());
    next.addEventListener('click', () => swiper.slideNext());
    ['progress', 'resize', 'update', 'slideChange'].forEach((event) => swiper.on(event, update));
    control.dataset.thumbnailNavigationReady = 'true';
    update();
    return true;
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('product-carousel .nailarts-thumbnail-nav').forEach((control) => {
      if (connect(control)) return;

      const slider = control.querySelector('[thumbnail-slider]');
      if (!slider || control.dataset.thumbnailNavigationWaiting) return;
      control.dataset.thumbnailNavigationWaiting = 'true';

      const observer = new MutationObserver(() => {
        if (connect(control)) observer.disconnect();
      });
      observer.observe(slider, { attributes: true, attributeFilter: ['class'] });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

